// Core
import { create } from "zustand";
import { devtools } from "zustand/middleware";

type ModalSheetType = {
  activeMenu: string | null;
  showMenu: (tab: string | null) => void;
  closeMenu: () => void;
};

const ModalSheetStore = create(
  devtools<ModalSheetType>((set) => ({
    activeMenu: null,
    showMenu: (menu: string | null) => set({ activeMenu: menu }),
    closeMenu: () => set({ activeMenu: null }),
  })),
);

export default ModalSheetStore;
